



















































































































































































































import Vue, { PropType } from "vue";
import { mapActions, mapGetters } from "vuex";
import { Jobs } from "@/interfaces/data_objects/jobs";
import { SearchJobObject } from "@/interfaces/shared/jobs/auto_complete_job_search";
import { TranslateResult } from "vue-i18n";
import { capitalize_text } from "@/utils/global";
import {
  APP_ASSESSMENT_ANSWERS,
  APP_ASSESSMENT_QUESTIONNAIRES,
  BULK_SUBMIT_ASSESSMENT_ANS,
  SEARCH_ANY_JOB
} from "@/store/modules/candidates/constants";
import { ScreeningQuestionsResponse } from "@/store/modules/recruiter/interfaces";
import { required_rules } from "@/utils/global";
import { QuestionType } from "@/interfaces/app_assessments";
import {
  BulkSubmitAssessmentAnsPayload,
  FetchAssessmentAnswersApiPayload,
  QuestionnairePayload,
  SubmitAssessmentAnswersApiPayload
} from "@/store/modules/candidates/interfaces";
import { GET_USER_DETAILS } from "@/store/modules/auth/constants";
import DataNotFound from "@/components/shared/DataNotFound.vue";
import Nationality from "@/utils/nationality";

export default Vue.extend({
  name: "JobSearchModal",
  components: {
    DataNotFound
  },
  data() {
    return {
      selected_searched_job: null,
      searched_jobs: [] as SearchJobObject[],
      search_input: null,
      first_time: true,
      dialog: true,
      steps: 1,
      screened_questions: [] as ScreeningQuestionsResponse[],
      selected_job: null as Jobs | null,
      data_message: "No Questions Found",
      loading: false,
      job_info_payload: [
        {
          text_field: "Nationality",
          label: "",
          value_field: "",
          type: "select",
          values: Nationality,
          data_type: "text"
        },
        {
          text_field: "Salary",
          label: "(AED)",
          value_field: "",
          type: "text_field",
          values: [],
          data_type: "number"
        },
        {
          text_field: "Notice period",
          label: "",
          value_field: "",
          type: "text_field",
          values: [],
          data_type: "text"
        }
      ]
    };
  },
  props: {
    hide_details: {
      type: Boolean,
      default: true
    },
    rules: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String as PropType<TranslateResult>
    },
    disabled: {
      type: Boolean,
      default: false
    },
    default_job: {
      type: Object as PropType<SearchJobObject | null>
    },
    screened_assessment_id: {
      type: Number
    },
    no_step_3: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters("auth", {
      get_user_details: GET_USER_DETAILS
    }),
    nationality(): string[] {
      return Nationality;
    },
    error_message(): string {
      return this.data_message;
    }
  },
  watch: {
    // Watcher for processing each string written in search field
    async search_input(value) {
      if (this.first_time) {
        this.first_time = false;
        return;
      }
      // If user press clear icon => reset job listing
      if (value === null) this.clear_autocomplete_search_value();
      // If user search value
      else if (value) {
        const obj = {
          job_title:
            typeof value === "string"
              ? value.toLowerCase()
              : value.text.toLowerCase,
          external: true,
          is_search_job: true
        };
        const result = await this.fetch_any_job(obj);
        if (result.length > 0) this.filter_searched_jobs(result);
      }
    },
    // Watcher when user select job from autocomplete results
    selected_searched_job(value) {
      // if (value) this.fetch_searched_job(value);
      if (value) {
        this.selected_job = value;
      }
    }
  },
  methods: {
    required_rules,
    ...mapActions("candidate", {
      fetch_any_job: SEARCH_ANY_JOB,
      get_assessment_question: APP_ASSESSMENT_QUESTIONNAIRES,
      bulk_submit_ans: BULK_SUBMIT_ASSESSMENT_ANS,
      get_assessment_answer: APP_ASSESSMENT_ANSWERS
    }),
    // Function to process search job to display in autocomplete dropdown
    filter_searched_jobs(jobs: Jobs[]) {
      this.searched_jobs = [];
      for (let job of jobs) {
        const obj = {
          text: capitalize_text(job.job_title),
          job_id: job.jid,
          created_by: job.created_by
        };
        this.searched_jobs.push(obj);
      }
    },
    // Function to reset state & pass null to parent
    clear_autocomplete_search_value() {
      this.reset_state();
    },
    // Reset state
    reset_state() {
      this.selected_searched_job = null;
      this.searched_jobs = [];
      this.search_input = null;
      this.screened_questions = [];
      this.selected_job = null;
    },
    async submit_form() {
      if (this.steps === 1) {
        this.screened_questions = [];
        if (this.selected_job !== null) {
          await this.fetch_assessment_questions();
        } else {
          this.reset_state();
          this.data_message = "No Job selected";
        }
        this.steps++;
      } else if (this.steps === 2) {
        const is_screened_questions =
          this.screened_questions && this.screened_questions.length;

        if (!is_screened_questions) {
          if (this.no_step_3) {
            return this.$emit("answer_submit", null);
          }
          this.steps++;
          return;
        }

        let valid_from = true;
        const forms = this.$refs.validate_form;
        this.loading = true;
        if (Array.isArray(forms)) {
          forms.forEach((form: any) => {
            if (form.validate && !form.validate()) {
              valid_from = false;
            }
          });
        }

        if (valid_from) {
          const submit_ans_payload: SubmitAssessmentAnswersApiPayload[] = [];

          this.screened_questions.forEach((val: ScreeningQuestionsResponse) => {
            submit_ans_payload.push({
              assessment_id: this.screened_assessment_id,
              question_id: val.id,
              answer: val.answer_text ?? "",
              answer_type: QuestionType.TEXT,
              user_id: this.get_user_details.id
            });
          });

          const payload: BulkSubmitAssessmentAnsPayload = {
            assessment_id: this.screened_assessment_id,
            answers: submit_ans_payload
          };
          // Submitting answers to the server
          const response = await this.bulk_submit_ans(payload);
          if (response) {
            if (this.no_step_3) {
              return this.$emit("answer_submit", null);
            }
            this.steps++;
          }
        }
        this.loading = false;
      } else if (this.steps === 3) {
        const forms = this.$refs.job_form;
        this.loading = true;

        if ((forms as any).validate()) {
          const result = this.job_info_payload.reduce(
            (acc: Record<string, string>, item: any) => {
              acc[item.text_field.toLowerCase().replace(" ", "_")] =
                item.value_field;
              return acc;
            },
            {}
          );
          if (result) {
            this.$emit("answer_submit", result);
          }
        }
      }
      this.loading = false;
    },
    async fetch_assessment_questions() {
      if (this.screened_assessment_id == null) {
        return (this.data_message = "Data not found");
      }
      const assessment_questions = await this.get_assessment_question({
        assessment_id: this.screened_assessment_id,
        job_id: this.selected_job?.job_id,
        created_by: this.selected_job?.created_by
      });

      if (assessment_questions && assessment_questions.length) {
        this.screened_questions =
          assessment_questions as ScreeningQuestionsResponse[];

        const question_ids = assessment_questions.map(
          (question: QuestionnairePayload) => question.id
        );
        if (question_ids && question_ids.length > 0) {
          // Fetch assessment answer
          const answer: FetchAssessmentAnswersApiPayload = {
            assessment_id: this.screened_assessment_id,
            page: 0,
            limit: 10,
            user_id: this.get_user_details.id,
            question_ids: question_ids
          };
          const answers = await this.get_assessment_answer(answer);
          if (answers && answers.results && answers.results.length) {
            this.data_message = "You have already answered these questions";
            this.screened_questions = [];
          }
        } else this.data_message = "No Questions Found";
      } else this.data_message = "No Questions Found";
    },
    get_options(index: number) {
      return this.screened_questions[index]?.question_options?.options;
    },
    on_back() {
      if (this.steps > 1) {
        this.steps--;
      }
    }
  }
});
